import { useEffect, useRef, useState } from "react";
import ArrowDown from "@/assetsV3/marketplace/ArrowDown";
import { useSolanaWallets } from "@privy-io/react-auth";
import { WalletTypeEnum } from "@/types/enums/WalletTypeEnum";
import SolBalanceIcon from "@/assetsV3/Wallet/SolIcon";
import PrivyIcon from "@/assetsV3/Wallet/PrivyIcon";
import SolanaIcon from "@/assetsV3/Wallet/SolanaIcon";
import { shortenAddress } from "@/utils/generalUtils";
import { useDispatch } from "react-redux";
import useSolanaTransaction from "@/callbacks/useSolanaTransaction";
import { setWallet } from "@/redux/slice/walletSlice";
import WalletSelectionSheet from "../BottomSheets/WalletSelectionSheet";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

interface Props {
  selectedWallet: string;
  setSelectedWallet: (val: string) => void;
  isEnableWalletSelection: boolean;
  isListedScreen?: boolean;
}

const PickWalletAccordion: React.FC<Props> = ({
  selectedWallet,
  setSelectedWallet,
  isEnableWalletSelection,
  isListedScreen = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { wallets } = useSolanaWallets();
  const [balance, setBalance] = useState<number>(0);
  const { getMultiWalletSolBalance } = useSolanaTransaction();
  const [balanceArray, setBalanceArray] = useState<number[]>();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const run = async () => {
      const _balanceArray = await getMultiWalletSolBalance(
        wallets.map((item) => item.address)
      );
      setBalanceArray(_balanceArray ?? []);
    };
    if (wallets.length > 0) {
      run();
    }
  }, [wallets.length]);

  useEffect(() => {
    const run = async () => {
      // if (!isEnableWalletSelection) {
      console.log(wallets, selectedWallet);
      const findIndex = wallets.findIndex(
        (item) => item.address.toLowerCase() === selectedWallet.toLowerCase()
      );
      if (balanceArray) {
        setBalance(
          Math.trunc((balanceArray?.[findIndex] ?? 0) * 100) / 100
        );
        setLoading(false);
      }
      // }
    };
    if (balanceArray && balanceArray.length > 0) {
      run();
    }
  }, [balanceArray, isEnableWalletSelection, selectedWallet]);


  const toggleAccordion = () => {
    setIsOpen(!isOpen); // Toggle accordion open/close
  };

  // Close accordion if click happens outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false); // Close the accordion if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const _selectedWalletObj = wallets.find(
    (item) => item.address.toLowerCase() === selectedWallet.toLowerCase()
  );

  return (
    <div
      className="relative rounded-[8px] w-full"
      ref={dropdownRef}
    >
      {/* Accordion Button */}
      <button
        onClick={() => {
          if (isEnableWalletSelection) {
            toggleAccordion();
          }
        }}
        className={`flex justify-between w-full py-[11px] h-[46px] px-[18px] text-left  font-normal text-outext-sub border-[1px] border-outstate-grayborder focus:outline-none ${!isEnableWalletSelection ? "opacity-50" : ""
          }  ${isOpen ? "rounded-x-[2px] rounded-t-[8px]" : "rounded-[8px]"}`}
      >
        {selectedWallet && !loading ? (
          <div className="w-full cursor-pointer transition-all">
            <div className="flex justify-between items-center w-full">
              <div className="flex gap-4">
                {_selectedWalletObj?.walletClientType ===
                  WalletTypeEnum.PHANTOM ? (
                  <SolanaIcon className={`fill-outstate-whitecompact`} />
                ) : (
                  <PrivyIcon
                    height={24}
                    width={30}
                    className="fill-outprimary-darker" />
                )}
                <div className="flex gap-1 items-center">
                  <SolanaIcon className="fill-outprimary-darker" />
                  <span className="font-bold text-outext-main text-base">
                    {balance.toFixed(2)}
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <p className="text-base text-outext-disabled font-normal">
                  {shortenAddress(selectedWallet ?? "")}
                </p>
                <ArrowDown className="fill-outicon-sub"/>
              </div>
            </div>
          </div>
        ) : (
          <>
            {loading ?
              <SkeletonTheme baseColor="#373737" highlightColor="#C0C0C0">
                <div
                  className="w-full"
                >
                  <div className="flex justify-between items-center w-full">
                    <div className="flex gap-4">
                      <PrivyIcon className="fill-outprimary-darker h-[24px] w-[20px]" />
                      <div className="flex gap-1 items-center">
                        <span className="font-bold text-outext-main text-base">
                          <Skeleton
                            count={1}
                            width={"50px"}
                            height={"20px"}
                            style={{ borderRadius: "8px" }}
                          />
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-end gap-2">
                      <p className="text-base text-outext-disabled font-normal">
                        <Skeleton
                          count={1}
                          width={"70px"}
                          height={"20px"}
                          style={{ borderRadius: "8px" }}
                        />
                      </p>
                      <ArrowDown className="fill-outicon-sub"/>
                    </div>
                  </div>
                </div>
              </SkeletonTheme>
              :
              <div className="flex justify-between items-center w-full">
                <span className={`text-outext-sub font-medium ${isListedScreen ? 'text-sm' : 'text-base'}`}>Pick wallet</span>
                <span>
                  <ArrowDown className="fill-outicon-sub"/>
                </span>
              </div>}
          </>
        )}
      </button>

      {/* Dropdown Content */}
      {isOpen && (
        <>

          <WalletSelectionSheet
            selectedWallet={selectedWallet}
            setSelectedWallet={setSelectedWallet}
            handleSheetChange={setIsOpen}
            bottomSheetState={isOpen}
          />
          <div className="max-sm:hidden absolute left-0 bg-outbackground-main right-0 overflow-hidden border-x-[1px] border-b-[1px] rounded-b-[8px] border-outstate-grayborder  shadow-lg z-10">
            <ul className="space-y-2 max-h-[110px] overflow-y-scroll no-scrollbar">
              {loading && [1, 1, 1].map((wallet, index) => (
                <SkeletonTheme key={index} baseColor="#373737" highlightColor="#C0C0C0">
                  <li
                    key={index}
                    className={`py-3 px-[18px] w-full gap-3 cursor-pointer transition-all hover:bg-outstroke-soft`}
                  >
                    <div className="flex justify-between items-center w-full">
                      <div className="flex gap-4">
                        <PrivyIcon className="fill-outprimary-darker h-[24px] w-[20px]" />
                        <div className="flex gap-1 items-center">
                          <span className="font-bold text-outext-main text-base">
                            <Skeleton
                              count={1}
                              width={"50px"}
                              height={"20px"}
                              style={{ borderRadius: "8px" }}
                            />
                          </span>
                        </div>
                      </div>
                      <p className="text-base text-outext-disabled font-normal">
                        <Skeleton
                          count={1}
                          width={"50px"}
                          height={"20px"}
                          style={{ borderRadius: "8px" }}
                        />
                      </p>
                    </div>
                  </li>
                </SkeletonTheme>
              ))}
              {wallets.map((wallet, index) => (
                <li
                  key={index}
                  onClick={() => {
                    const walletData = {
                      address: wallet.address,
                      walletConnectType: wallet.walletClientType,
                    };
                    dispatch(setWallet(walletData));
                    setSelectedWallet(wallet.address);
                    if (balanceArray) {
                      setBalance(
                        Math.trunc((balanceArray?.[index] ?? 0) * 100) / 100
                      );
                    }
                    setIsOpen(false);
                  }}
                  className={`py-3 px-[18px] w-full gap-3 cursor-pointer transition-all hover:bg-outstroke-soft ${selectedWallet === wallet.address ? "bg-outstroke-soft" : ""}`}
                >
                  <div className="flex justify-between items-center w-full">
                    <div className="flex gap-4">
                      {wallet.walletClientType === WalletTypeEnum.PHANTOM ? (
                        <SolBalanceIcon className="fill-outprimary-darker h-[24px] w-[24px]" />
                      ) : (
                        <PrivyIcon className="fill-outprimary-darker h-[24px] w-[20px]" />
                      )}
                      <div className="flex gap-1 items-center">
                        <SolanaIcon width={20} height={20} className="fill-outprimary-darker" />
                        <span className="font-bold text-outext-main text-base">
                          {Math.trunc((balanceArray?.[index] ?? 0) * 100) / 100}
                        </span>
                      </div>
                    </div>
                    <p className="text-base text-outext-disabled font-normal">
                      {shortenAddress(wallet.address?.toString() ?? "")}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default PickWalletAccordion;
